import groupBy from 'lodash.groupby';

import { sortByPropAsc } from '../../../services/sort-service';

/**
 * @typedef {object} SplitShipEntity
 * @property {string} fulfillmentPlanId
 * @property {string} fulfillmentPlanItemId
 * @property {number} quantity
 */

/**
 * Generates an entity checksum from split ship entities
 * @param {Array<SplitShipEntity>} initialSplitShipEntities
 * @returns {string}
 */
export const generateSplitShipEntityChecksum = (initialSplitShipEntities) => {
  const itemsGroupedByFulfillmentPlanId = groupBy(initialSplitShipEntities, 'fulfillmentPlanId');

  const entities = Object.entries(itemsGroupedByFulfillmentPlanId).map(([fulfillmentPlanId, groupItems]) => {
    const fpItems = {};
    groupItems.sort(sortByPropAsc('fulfillmentPlanItemId'));
    groupItems.forEach((fpItem) => {
      fpItems[fpItem.fulfillmentPlanItemId] = { quantity: fpItem.quantity };
    });

    return { fulfillmentPlanId, items: fpItems };
  });

  return btoa(JSON.stringify(entities));
};
